import { isDetachedPortalApp } from '@/utils/portalMode'

/** Hostnames that serve client portal only (no admin console). */
const DEFAULT_CLIENT_PORTAL_HOSTS = ['yassir.valt.africa']

function parseHostsFromEnv(): string[] {
  const raw = import.meta.env.VITE_CLIENT_PORTAL_HOSTS
  if (!raw || typeof raw !== 'string') return []
  return raw
    .split(',')
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean)
}

/** All hostnames configured as client-portal-only entry points. */
export function getClientPortalHosts(): string[] {
  const fromEnv = parseHostsFromEnv()
  const merged = [...DEFAULT_CLIENT_PORTAL_HOSTS.map((h) => h.toLowerCase()), ...fromEnv]
  return [...new Set(merged)]
}

/**
 * True when the app is served from a client-portal-only host
 * (e.g. clients.valt.africa, yassir.valt.africa).
 */
export function isClientPortalHost(hostname?: string): boolean {
  if (isDetachedPortalApp()) return true
  const host = (hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '')).toLowerCase()
  if (!host) return false
  if (host.startsWith('clients.')) return true
  return getClientPortalHosts().includes(host)
}

export function isContractorAppPath(pathname: string): boolean {
  return (
    pathname === '/clients/login' ||
    pathname === '/clients/change-password' ||
    pathname.startsWith('/clients/recover-password') ||
    pathname === '/contractor' ||
    pathname.startsWith('/contractor/')
  )
}
